import React from 'react';
import {
  Dialog,
  DialogActions,
  DialogContent,
  Grid,
  IconButton
} from '@material-ui/core';
import useStyles from './useStyles';
import CustomizedTypography from '../CustomizedTypography';
import { Close } from '@material-ui/icons';

export interface CustomizedDialogProps {
  id?: string;
  icon?: React.ReactNode;
  title: string | React.ReactNode;
  open: boolean;
  onClose: () => void;
  closeButton?: boolean;
  maxWidth?: number;
  color?: 'primary' | 'error' | 'warning' | 'success';
  gutter?: number;
  fullWidth?: boolean;
  borderRadius?: number;
  actions?: React.ReactNode;
  scroll?: 'paper' | 'body';
}
/**
 * @param icon ReactNode
 * @param title string | ReactNode
 * @param open boolean
 * @param onClose function
 * @param maxWidth number
 * @param color 색상
 * @param closeButton 닫기버튼 유무(boolean)
 * @param gutter Dynamic Content 양옆 여백(number)
 * @param fullWidth
 * @param borderRadius number
 */
const CustomizedDialog: React.FC<CustomizedDialogProps> = (props) => {
  const classes = useStyles({ ...props });
  return (
    <Dialog
      id={props.id}
      open={props.open}
      keepMounted={false}
      maxWidth={'lg'}
      scroll={props.scroll}
      fullWidth
      onClose={props.onClose}
      classes={{
        paper: classes.paper,
        paperWidthLg: classes.root,
        paperFullWidth: classes.paperFullWidth
      }}
    >
      {typeof props.title === 'object' ? (
        <Grid container alignItems="center" className={classes.titleRoot}>
          {props.title}
        </Grid>
      ) : (
        <Grid container alignItems="center" className={classes.titleRoot}>
          <Grid container className={classes.iconRoot}>
            {props.icon}
          </Grid>
          <CustomizedTypography className={classes.title}>
            {props.title}
          </CustomizedTypography>

          {props.closeButton && (
            <IconButton onClick={props.onClose} className={classes.closeButton}>
              <Close />
            </IconButton>
          )}
        </Grid>
      )}

      <DialogContent className={classes.dynamicContentRoot}>
        <Grid container>{props.children}</Grid>
      </DialogContent>
      {props.actions && (
        <DialogActions className={classes.actions}>
          {props.actions}
        </DialogActions>
      )}
    </Dialog>
  );
};

export default CustomizedDialog;
